module.exports = __webpack_public_path__ + "img/meishi1.9a9cf83b.png";